import React from 'react';
import { createUseStyles, Text, Icon, useTheme } from '@Sage/hoi-poi-ui';

import styles from './styles';
const useStyles = createUseStyles(styles, 'CopilotSidebarTabHeader');

const CopilotSidebarTabHeader = ({ title, onBack, sideComponent }) => {
    const classes = useStyles();
    const theme = useTheme();
    return (
        <div className={classes.root}>
            <div className={classes.title}>
                {onBack && (
                    <Icon
                        name="arrowBack"
                        onClick={onBack}
                        size="large"
                        color={theme.colors.primary.black}
                    />
                )}
                <Text type="h4">{title}</Text>
            </div>
            {sideComponent}
        </div>
    );
};

export default CopilotSidebarTabHeader;
